import React from 'react'
import styled from 'styled-components'
import { Flex, Heading, Image, Link, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Container from 'components/Layout/Container'
import { useWeb3React } from '@web3-react/core/core/core'
import SunburstSvg from './SunburstSvg'
import CompositeImage from './CompositeImage'

const BgWrapper = styled.div`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`

const StyledSunburst = styled(SunburstSvg)`
  height: 350%;
  width: 350%;

  ${({ theme }) => theme.mediaQueries.xl} {
    height: 400%;
    width: 400%;
  }
`
const ImageWrapper = styled.div`

margin-right: 6px;
${({ theme }) => theme.mediaQueries.md} {
  margin-right: 8px;
}
`

const Wrapper = styled(Flex)`
  z-index: 1;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

const FloatingPancakesWrapper = styled(Container)`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  visibility: hidden;

  ${({ theme }) => theme.mediaQueries.md} {
    visibility: visible;
  }
`

const TopLeftImgWrapper = styled(Flex)`
  position: absolute;
  left: 0;
  top: 0;
`

const BottomRightImgWrapper = styled(Flex)`
  position: absolute;
  right: 0;
  bottom: 0;
`

const topLeftImage = {
  path: '/images/home/flying-pancakes/',
  attributes: [
    { src: '1-bottom', alt: 'Pancake flying on the bottom' },
    { src: '1-left', alt: 'Pancake flying on the left' },
    { src: '1-top', alt: 'Pancake flying on the top' },
  ],
}

const bottomRightImage = {
  path: '/images/home/flying-pancakes/',
  attributes: [
    { src: '2-bottom', alt: 'Pancake flying on the bottom' },
    { src: '2-top', alt: 'Pancake flying on the top' },
    { src: '2-right', alt: 'Pancake flying on the right' },
  ],
}

const Footer = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()

  return (
    <>
      <Flex  justifyContent="left" alignItems="center" >
      <ImageWrapper>
      <a href="https://twitter.com/HunVizslainu" target="blank"> <Image src="/images/pixel/twittericon.png" width={25} height={25} mr={20} mt={3}/></a> 
      </ImageWrapper>
      <ImageWrapper>
      <a href="https://t.me/hungarianvizslainucoin" target="blank"> <Image src="/images/pixel/telegram.png" width={25} height={25} mr={20}     mt={3}/> </a> 
      </ImageWrapper>
      <ImageWrapper>
      <a href="https://www.youtube.com/c/HungarianVizslaInu/videos" target="blank"> <Image src="/images/pixel/youtubeicon.png" width={25} height={25} mr={20}   mt={3}/></a> 
      </ImageWrapper>
      <ImageWrapper>
      <a href="https://www.facebook.com/groups/188822129774638" target="blank"> <Image src="/images/pixel/facebook.png" width={25} height={25}   mr={20} mt={3}/></a> 
      </ImageWrapper>
         </Flex>
    </>

  )
}

export default Footer
